<template>
  <div>
    <v-container fluid pt-0>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card width="100%">
            <div
              id="contVideo"
              ref="contVideo"
              class="grey lighten-5 resizable"
              :style="{ width: '100%', height: height }"
            >
              <resize-observer @notify="setWidth()" />
              <youtube
                id="youtube"
                ref="youtube"
                :video-id="videoId"
                width="100%"
                height="100%"
                @ready="ready"
                @playing="playing"
              />
            </div>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { Youtube } from 'vue-youtube'

export default {
  components: { Youtube },
  props: {
    video: {
      type: Object,
      required: false,
      default: () => {},
    },
    time: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  data() {
    return {
      width: 0,
      newTime: false,
    }
  },
  computed: {
    videoId() {
      if (this.video.src.includes('youtube')) {
        return this.video.src.split('?v=')[1]
      } else if (this.video.src.includes('youtu.be')) {
        return this.video.src.split('/')[this.video.src.split('/').length - 1]
      } else return ''
    },
    player() {
      return this.$refs.youtube.player
    },
    height() {
      return this.width * 0.56 + 'px' || '0px'
    },
  },
  watch: {
    time(val) {
      if (val && Number.isInteger(val) && !this.newTime) this.setTime(val)
      else this.newTime = false
    },
  },
  mounted() {},
  methods: {
    setWidth() {
      if (this.$refs.contVideo && this.$refs.contVideo.clientWidth) {
        this.width = this.$refs.contVideo.clientWidth
      } else {
        setTimeout(() => {
          this.setWidth()
        }, 1000)
      }
    },
    playing() {
      // console.log('\o/ we are watching!!!')
    },
    getTime() {
      this.newTime = true
      this.player.pauseVideo()
      this.player.getCurrentTime().then((time) => this.$emit('addEvent', time))
    },
    setTime(time) {
      this.player.seekTo(time > 15 ? time - 15 : 0)
      // if(pause) this.player.pauseVideo()
    },
    ready() {
      this.player.getDuration().then((duration) => {
        this.setWidth()
        this.$emit('duration', Math.floor(duration))
      })
    },
  },
}
</script>
